import { useCallback, useEffect, useRef } from 'react';
import Frame from 'react-frame-component';
import './messageItem.print.css';
import { HeaderPrintableContent } from './widgets';

interface IPrintableContentProps {
  title?: string;
  print?: boolean;
  children: React.ReactNode;
  printStyle?: string;
  onAfterPrint?: () => void;
}

export const PrintableContent = (props: IPrintableContentProps) => {
  const frameRef = useRef<HTMLIFrameElement>(null);

  const handlePrint = useCallback(() => {
    if (frameRef.current) {
      const iframe = frameRef.current.contentWindow;
      if (iframe) {
        iframe.focus();
        iframe.print();
      }
    }
  }, []);

  useEffect(() => {
    const iframe = frameRef.current?.contentWindow;
    if (!iframe || typeof props.onAfterPrint !== 'function') return;

    const printCallback = (mql: MediaQueryListEvent) => {
      if (!mql.matches) props.onAfterPrint?.();
    };

    iframe.onafterprint = props.onAfterPrint;

    if (!iframe.matchMedia) return;

    const mediaQueryList = iframe.matchMedia('print');
    mediaQueryList.addEventListener('change', printCallback);
    return () => {
      mediaQueryList.removeEventListener('change', printCallback);
    };
  }, [props.onAfterPrint]);

  useEffect(() => {
    if (props.print) {
      handlePrint();
    }
  }, [props.print, handlePrint]);

  return (
    <Frame
      ref={frameRef}
      style={{ width: 0, height: 0, position: 'absolute', top: '-10000px', left: '-1000px' }}
      head={<style>{props.printStyle}</style>}
      initialContent={`<!DOCTYPE html><html><head><title>${props.title || 'Print'}</title></head><body><div></div></body></html>`}
    >
      <HeaderPrintableContent>{props.children}</HeaderPrintableContent>
    </Frame>
  );
};
